import { render, staticRenderFns } from "./CommonTab.vue?vue&type=template&id=1f197fa5&scoped=true"
import script from "./CommonTab.vue?vue&type=script&lang=js"
export * from "./CommonTab.vue?vue&type=script&lang=js"
import style0 from "./CommonTab.vue?vue&type=style&index=0&id=1f197fa5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f197fa5",
  null
  
)

export default component.exports